export interface AppBarProps {
  onMenuClick: () => void;
  /** Place name; null while loading / unknown */
  locationLabel: string | null;
  /** Decimal coordinates, e.g. "41.4062, -73.7408" */
  coordinates: string;
}

export default function AppBar({ onMenuClick, locationLabel, coordinates }: AppBarProps) {
  return (
    <header className="sticky top-0 z-20 flex h-[72px] items-center justify-between gap-3 bg-surface px-page shadow-sm">
      <div className="min-w-0 flex-1">
        <p className="truncate text-[18px] font-medium leading-tight text-on-surface">
          {locationLabel ?? "Loading location…"}
        </p>
        <p
          className="truncate text-[12px] leading-tight text-on-surface-variant"
          title={coordinates}
        >
          {coordinates}
        </p>
      </div>

      <button
        type="button"
        aria-label="Edit location"
        onClick={onMenuClick}
        className="flex h-12 w-12 shrink-0 items-center justify-center rounded-full bg-primary-container text-[14px] font-medium text-primary transition-colors hover:opacity-90 active:opacity-80 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary"
      >
        Edit
      </button>
    </header>
  );
}
